export enum SSO_METHOD {
  OICD = 'oidc',
}

export enum SSO_DESTINATION {
  TRAVELER_CASHBACK = 'traveler_cashback',
}

export enum MEMBER_MAPPING {
  MEMBER_ID = 'memberId',
  EXTERNAL_MEMBER_ID = 'externalMemberId',
}

export interface ISSOConfig {
  id: string
  ssoMethod: SSO_METHOD
  clientId: string
  ssoDestination: SSO_DESTINATION
  memberMappingProperty: MEMBER_MAPPING
  sourceMappingProperty: string
  created: Date
  updated?: Date
  oAuthClientId: string
  oAuthDomain: string
  oAuthGrantType: string
  scopes: string
  audience?: string
}

export interface ISSOConfigRequest {
  ssoDestination: SSO_DESTINATION
}
